<template>
  <div class="v-code-contain" v-if="vcode">
    <div class="v-code" @click="changeSelect(vcode)">
      <div class="vcode-info">
        <div class="text">
          <div class="title">{{vcode.description}}</div>
          <div class="limit-time">有效期至{{vcode.endTimeStr | formatTime}}</div>
        </div>
        <div class="img" >
          <img :src="vcode.picUrl" v-if="vcode.picUrl"/>
        </div>
      </div>
      <div class="vcode-action" :class="{'no-des':!vcode.ruleDesc,'open':isShowDesc}">
        <div class="code" @click.stop="handleToggle">
          {{vcode.couponCode | formatNum}}
        </div>
        <div class="action" :class="{checkBtn:btnType == 1}" v-if="showBtn">
          <!-- 选择v码 -->
          <template v-if="btnType == 1">
            <v-checkbox v-model="isSelect" unCheckboxColor="rgba(0,0,0,0.52)" checkboxColor="#333"></v-checkbox>
          </template>
          <template v-else-if="btnType == 0">
            <a class="btn" :href="vcode.wapUseUrl">立即使用</a>
          </template>
          <template v-else-if="btnType == 2">
            <a class="btn" @click="toOrderDetail(vcode)">查看订单</a>
          </template>
          <template v-else-if="btnType == 3">
            <a class="btn disable">不可用</a>
          </template>
        </div>
      </div>
    </div>
    <div :class="['bootom-desc', isShowDesc ? 'open' : '']">
      <collapse>
        <div v-if="vcode.ruleDesc && isShowDesc" class="desc-open">
          <p v-html="vcode.ruleDesc"></p>
        </div>
      </collapse>
    </div>
  </div>
  
</template>

<script>
import create from '../create' 
import config from 'config' 
import env from 'utils/clientEnv' 

export default create({
  props: {
    btnType: {
      // 右边按钮类型 0是立即使用按钮 1是打勾按钮
      type: [String, Number],
      default: 0
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    vcode: {
      // vcode数据
      type: Object,
      default: {},
      required: true
    },
    isSelect: {
      // 是否选中
      type: Boolean
    },
    orderNo: {
      type: [String, Number],
      default: 0
    },
    index: String | Number//当前序列位置
  },
  name: 'vcode',
  filters: {
    formatNum(value) {
      return value && value.replace(/(.{4})/g, '$1 ')
    },
    formatTime(value){
      return value && value.replace(/\./g, '/')
    }
  },
  data() {
    return {
      // isReceive: false, // 组件内自身状态 是否已经点击立即领取按钮
      isShowDesc: false, // 是否显示vcode说明
      env: env, // 环境判断
      imageHost: config.path.imageHost, // 路径
      initTime: Date.now(),
      tempTerminal:
        this.$route.query.tempTerminal == '0' || this.$route.query.tempTerminal == '1'
          ? Number.parseInt(this.$route.query.tempTerminal)
          : -1,
    }
  },
  watch: {
    isShowDesc(isShow) {
      if (this.vcode.description) {
        if (isShow) {
          this.$emit('toggleDesc', true)
        } else {
          this.$emit('toggleDesc', false)
        }
      }
    }
  },
  created() {},
  mounted() {
  },
  methods: {
    // 切换vcode底部使用说明
    handleToggle() {
      if (this.vcode?.description) {
        this.isShowDesc = !this.isShowDesc
        // 执行传入的方法
        this.$emit('showMore',this.isShowDesc)
      }
    },
    /**
     * @description: 改变选择的vcode
     * @param id {String}
     * @return: viod
     */
    changeSelect(vcode) {
      if (this.btnType == 1) {
        this.$emit('changeSelect', {couponNum:vcode.couponNum,index:this.index})
      }
    },
    // TODO:需要确认公控样式，公控不存在该类样式
    toastSuccess(msg) {
      this.$toast({
        type: 'success',
        message: msg
      })
    },
    toOrderDetail(val) {
      this.$router.push(`/my/order/detail?orderNo=${val.orderNo}&tempTerminal=${this.tempTerminal}`)
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
